import { useFetch } from '../../../hooks/useFetch';
import {
  errorNotification,
  successNotification,
} from '../../../providers/mantine-notifications';
import {
  CreateEpiRoundData,
  EpiRoundDto,
  PaginatedEpiRounds,
  createEpiRoundRequest,
  deleteEpiRoundRequest,
  listEpiRoundsRequest,
  listPendingEpiRoundItemsRequest,
  showEpiRoundRequest,
  updateEpiRoundRequest,
} from '../../epi-rounds';

export function useListEpiRounds() {
  const {
    fetchData,
    state: { data: rounds, loading },
  } = useFetch<PaginatedEpiRounds>();

  const fetch = (params?: {
    sector?: string;
    unit?: string;
    page?: number;
    limit?: number;
  }) =>
    fetchData({
      fetcher: () => listEpiRoundsRequest(params),
      onError: () =>
        errorNotification({
          title: 'Erro ao listar rondas.',
          message: 'Tente novamente.',
        }),
    });

  return { fetch, rounds, loading };
}

export function useShowEpiRound() {
  const {
    fetchData,
    state: { data: round, loading },
  } = useFetch<EpiRoundDto>();

  const fetch = (id: number) =>
    fetchData({
      fetcher: () => showEpiRoundRequest(id),
      onError: () =>
        errorNotification({
          title: 'Erro ao buscar ronda.',
          message: 'Tente novamente.',
        }),
    });

  return { fetch, round, loading };
}

export function useCreateEpiRound() {
  const {
    fetchData,
    state: { loading },
  } = useFetch<void>();

  const create = (data: CreateEpiRoundData, onSuccess?: () => void) =>
    fetchData({
      fetcher: () => createEpiRoundRequest(data),
      onError: () =>
        errorNotification({
          title: 'Erro ao criar ronda.',
          message: 'Tente novamente.',
        }),
      onSuccess: () => {
        successNotification({ title: 'Ronda criada!', message: '' });
        onSuccess?.();
      },
    });

  return { create, loading };
}

export function useUpdateEpiRound() {
  const {
    fetchData,
    state: { loading },
  } = useFetch<void>();

  const update = (
    id: number,
    data: Partial<CreateEpiRoundData>,
    onSuccess?: () => void,
  ) =>
    fetchData({
      fetcher: () => updateEpiRoundRequest(id, data),
      onError: () =>
        errorNotification({
          title: 'Erro ao atualizar ronda.',
          message: 'Tente novamente.',
        }),
      onSuccess: () => {
        successNotification({ title: 'Ronda atualizada!', message: '' });
        onSuccess?.();
      },
    });

  return { update, loading };
}

export function useDeleteEpiRound() {
  const {
    fetchData,
    state: { loading },
  } = useFetch<void>();

  const remove = (id: number, onSuccess?: () => void) =>
    fetchData({
      fetcher: () => deleteEpiRoundRequest(id),
      onError: () =>
        errorNotification({
          title: 'Erro ao excluir ronda.',
          message: 'Tente novamente.',
        }),
      onSuccess: () => {
        successNotification({ title: 'Ronda excluída.', message: '' });
        onSuccess?.();
      },
    });

  return { remove, loading };
}

export function useListPendingEpiRoundItems() {
  const {
    fetchData,
    state: { data: items, loading },
  } = useFetch<any[]>();

  const fetch = () =>
    fetchData({
      fetcher: () => listPendingEpiRoundItemsRequest(),
      onError: () =>
        errorNotification({
          title: 'Erro ao listar pendências.',
          message: 'Tente novamente.',
        }),
    });

  return { fetch, items, loading };
}
